module.exports = __webpack_public_path__ + "img/handbook_popup_none.e7035632.png";